import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import {
  urlResolverGetAgb,
  urlResolverGetPrivacySecurity,
} from '../../../url-handling'

export const StoryblokMagazineNewsletterSubscriptionTos: FC = () => {
  const globalConfig = useGlobalConfigContext()

  const conditionsLink = (chunks: ReactNode[]): JSX.Element => (
    <Link
      color="inherit"
      href={urlResolverGetAgb(globalConfig)}
      rel="noreferrer"
      target="_blank"
    >
      {chunks}
    </Link>
  )

  const policyLink = (chunks: ReactNode[]): JSX.Element => (
    <Link
      color="inherit"
      href={urlResolverGetPrivacySecurity(globalConfig)}
      rel="noreferrer"
      target="_blank"
    >
      {chunks}
    </Link>
  )

  return (
    <p>
      <FormattedMessage
        id="magazineNewsletterSubscription.tosAgreement"
        values={{
          conditionsLink,
          policyLink,
        }}
      />
    </p>
  )
}
